import { render } from "./CurrentStocks.vue?vue&type=template&id=bd435e16&scoped=true"
import script from "./CurrentStocks.vue?vue&type=script&lang=js"
export * from "./CurrentStocks.vue?vue&type=script&lang=js"

import "./CurrentStocks.vue?vue&type=style&index=0&id=bd435e16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd435e16"]])

export default __exports__